import { LandingPageNumber } from '../constants'

export default function useLandingWebComponent(landingContext) {
  const {
    urlState,
    offer,
    globalState,
    sessionLandingType,
    generatedLandingType,
    experienceState: { landingTypeFromUrl }
  } = landingContext

  const { experienceState } = landingContext
  if (process.env.BUILD_STAGE === 'build-html') {
    landingContext.usingLandingWebComponent = !!generatedLandingType
    return
  }

  const isOnLandingPage = urlState.p === LandingPageNumber
  const hasWebComponentConfigured = !!globalState.environment.funnelWebComponentUrl
  const isReviewOffer = urlState.pa?.includes('reviewoffer') // QQ, Edit, Resubmit
  const isResubmitOffer = offer?.isExpired
  const matchingLandingType = landingTypeFromUrl === sessionLandingType

  experienceState.isLandingWebComponent = hasWebComponentConfigured && matchingLandingType
  landingContext.usingLandingWebComponent = isOnLandingPage && hasWebComponentConfigured && matchingLandingType
  landingContext.isReviewResubmitOffer = isReviewOffer || isResubmitOffer
}
